if (!customElements.get('elonail-collection-load-more')) {
  customElements.define(
    'elonail-collection-load-more',
    class ElonailCollectionLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-load-more-button]');
        if (!this.button || this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick = async () => {
        const nextUrl = this.dataset.nextUrl;
        const sectionId = this.dataset.sectionId;
        if (!nextUrl || !sectionId || this.button.disabled) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', sectionId);

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`Unable to load products: ${response.status}`);

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = parsed.querySelector('#product-grid');
          const currentGrid = document.querySelector('#product-grid');

          if (!incomingGrid || !currentGrid) throw new Error('Product grid was not found.');

          const incomingItems = Array.from(incomingGrid.children);
          const firstNewItem = incomingItems[0] || null;

          incomingItems.forEach((item) => currentGrid.appendChild(item));

          const incomingLoader = parsed.querySelector('elonail-collection-load-more');
          if (incomingLoader?.dataset.nextUrl) {
            this.dataset.nextUrl = incomingLoader.dataset.nextUrl;
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          } else {
            this.remove();
          }

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(currentGrid);
          }

          requestAnimationFrame(() => {
            firstNewItem?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        } catch (error) {
          console.error(error);
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      };
    }
  );
}
